import {XMLParser} from 'fast-xml-parser';

const store = {
  debug: true,
  state: {
    rssFeed: []
  },
  async fetchRssFeedAction () {
    if (this.state.rssFeed.length === 0) {
      if (this.debug) console.log('fetchRssFeedAction triggered')
      this.state.rssFeed = await getFeed();
      console.info('got rssFeed', this.state.rssFeed.length);
    }
  },
  clearRssFeedAction () {
    if (this.debug) console.log('clearRssFeedAction triggered')
    this.state.rssFeed = []
  }
}

async function getFeed() {
  let response = await fetch('https://feed.podbean.com/domsdagur/feed.xml');
  let xml = await response.text();
  const parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: 'attr_'
  });
  return parser.parse(xml).rss.channel.item;
}

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js